import { ItemList, ItemListRowProps } from '@app/form_components';
import {
  FormControlProps,
  RichTextReplyButton
} from '@app/types';
import { RichTextReplyButtonForm } from './RichTextReplyButtonForm';

export type RichTextReplyButtonsProps = FormControlProps<RichTextReplyButton[]>;

export function RichTextReplyButtonsForm({
  value,
  ...listProps
}: RichTextReplyButtonsProps) {
  return (
    <ItemList<RichTextReplyButton>
      {...listProps}
      getKey={(replyButton) => replyButton.id}
      label='Reply Buttons'
      renderForm={(props) => <RichTextReplyButtonForm {...props} />}
      renderRow={(props) => <RichTextReplyButtonRow {...props} />}
      value={parseButtons(value)}
    />
  );
}

function parseButtons(buttons: RichTextReplyButtonsProps['value']): RichTextReplyButton[] {
  return (
    buttons?.map((button, i) => {
      return {
        ...button,
        id: i + 1,
        title:
          window.apm.serialized.components.intents.find(
            (int) => int.id === button.intent
          )?.name || ''
      };
    }) || []
  );
}

type RichTextReplyButtonRowProps = ItemListRowProps<RichTextReplyButton>;

function RichTextReplyButtonRow({ value, styles }: RichTextReplyButtonRowProps) {
  const { label, url, title, urlType } = value;
  return (
    <>
      <h4>{title}</h4>
      <MultiField {...label} />
      <div className={styles.textLine}>
        <i className={'fe icon-link-2'} /> type: {urlType}
      </div>
      <div className={styles.textLine}>
        <i className={'fe icon-link-2'} /> url: {url}
      </div>
    </>
  );
}

function MultiField(labels: Record<string, string>) {
  return (
    <div>
      {Object.entries(labels).map(([key, value]) => (
        <div key={key}>
          <i className={'fe icon-hash'} /> {key}: {value}
        </div>
      ))}
    </div>
  );
}
